module.exports = __webpack_public_path__ + "static/media/IMG_1353.ac494cf2.jpg";